(function($) {
  $(function() {

    $(document).on('click', '.js-accordion-trigger', function() {
      var $item = $(this).closest('.js-accordion-item');
      var $content = $item.find('.c-accordion__itemcontent');

      if ($item.hasClass('c-accordion__item--active')) {
        $item.removeClass('c-accordion__item--active');
        $content.css('max-height', 0);
      } else {
        $item.addClass('c-accordion__item--active');
        $content.css('max-height', $content[0].scrollHeight + 'px');
      }
    });

  });
})(jQuery);
